import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  CircularProgress,
  Typography,
  Select,
  Checkbox,
  MenuItem,
  ListItemText,
  Grid,
} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import DeleteIcon from "@material-ui/icons/Delete";
import axios from "axios";
import StyledButton from "../../../common/models/Button";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { appUrl } from "../../../../utils/config";
import { he } from "date-fns/locale";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "1200px",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
      height: "30px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(4),
  },
  iconBtn: {
    padding: "4px",
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 8,
  },
  saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton: {
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
}));

const ProductTypeTab = (props) => {
  const { addSponsorList, rowData, rowNetwork, updateNetworkData } = props;
  const classes = useStyles();

  const [productTypes, setProductTypes] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [savingStates, setSavingStates] = useState({});
  const [isSaving, setIsSaving] = useState(false); // Track save & next button loading
  const [rowErrors, setRowErrors] = useState({});

  const dispatch = (action) => {
    if (action.type === "OPEN_BACKDROP") {
    } else if (action.type === "DESTROY_BACKDROP") {
    }
  };

  const network = addSponsorList?.data?.network || rowNetwork;
  const networkUrl = updateNetworkData?.ecosystemUrl || rowData?.networkURL;
  const fetchProductOptions = async () => {
    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchMaterialTypes/false`;
      const response = await axios.get(url);
      // materialTypeList is at root level of response (not nested under data)
      const list = response?.data?.materialTypeList;
      if (Array.isArray(list)) {
        const options = list
          .filter((item) => item.activated === true)
          .map((item) => ({
            id: item.materialTypeID,
            name: item.materialTypeName,
          }));
        setProductOptions(options);
      } else {
        console.error("Failed to fetch material type options.");
      }
    } catch (error) {
      console.error("Error fetching material type options:", error);
    }
  };
 
  const fetchProductTypes = async () => {
    setError(null);
    setLoading(true);
    dispatch({ type: "OPEN_BACKDROP" });

    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchProductTypes/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;

           if (data?.status === true || data?.status === "true") {
        const list = data.productTypeList || [];
          const formatted = list.map((item, index) => ({
          id: item.productTypeID || `ID-${index + 1}`,
          name: item.productTypeName || "",
          type: item.productType,
          selected: !!item.activated,
          isNew: false,
          associatedMaterialTypes: (
            item?.associatedMaterialTypesList || []
          ).map((product) => ({
            id: product.materialTypeID,
            name: product.materialTypeName,
            productDomEqualsMaterialDom: product.productDomEqualsMaterialDom ?? false,
          })),
          lastUpdatedBy: item.lastUpdatedBy || "",
        }));

        setProductTypes(formatted);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      dispatch({ type: "DESTROY_BACKDROP" });
    }
  };
  useEffect(() => {
    fetchProductTypes();
  }, []);

  // console.log("ProductTypes",productTypes)
  const saveNewProductType = async (productType) => {
    try {
      // Prepare the payload
      const payload = {
        ecosystemId: addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
        sponsorId:
          addSponsorList?.data?.organizationId || rowData?.organizationId,
        // receiverLegalNames:[],
        // lastUpdatedBy: productTypes?.lastUpdatedBy || "",
        productTypeList: [
          {
            productTypeName: productType.name,
            productType: "New", // Assuming all new product types are of type "New"
            activated: productType.selected, // Use the `selected` property to set activation status
            associatedMaterialTypesList: productType?.products?.map(
              (product) => ({
                materialTypeName: product?.name, // Product type name
                materialTypeID: product?.id, // Product type ID
                productDomEqualsMaterialDom: product?.productDomEqualsMaterialDom ?? false,
              })
            ),
          },
        ],
      };

      // Call the API
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/addProductTypes`;
      const response = await axios.post(url, payload);
      props.setProductType((prev) => !prev);

      // Handle API response
      if (response.data?.status === true || response.data?.status === "true") {
        return true; // Indicate success
      } else {
        console.error("Failed to save new product type.");
        return false; // Indicate failure
      }
    } catch (error) {
      console.error("Error saving new product type:", error);
      return false; // Indicate failure
    }
  };

  const handleSaveNewProductType = async (index) => {
    const productType = productTypes[index];
    if (savingStates[index]) return;
    const errors = {};
    if (!productType.name?.trim()) {
      errors.name = "Product Type is required.";
    }
    const hasEmptyMaterial =
      !productType.products?.length || productType.products.some((p) => p.id === null);
    if (hasEmptyMaterial) {
      errors.materials = "Please select a material type for all rows or remove the empty ones.";
    }
    if (Object.keys(errors).length > 0) {
      setRowErrors((prev) => ({ ...prev, [index]: errors }));
      return;
    }
    setRowErrors((prev) => ({ ...prev, [index]: {} }));
    setSavingStates((prev) => ({ ...prev, [index]: true }));
    const success = await saveNewProductType(productType);
    if (success) {
      await fetchProductTypes();
    } else {
      console.error("Failed to save new product type.");
    }
    setSavingStates((prev) => ({ ...prev, [index]: false }));
  };
  const handleNextClick = async () => {
    try {
      const isAnyProductTypeSelected = productTypes.filter(
        (productType) => productType.isUpdated && !productType.isNew
      );
      if (!isAnyProductTypeSelected.length) {
        props.handleNext(); // Directly move to the next tab
        return;
      }
      if (productTypes.every((productType) => !productType.selected)) {
        setErrorMessage("Please enable at least one in toggle mode.");
        return;
      }

      const invalidRows = isAnyProductTypeSelected.filter(
        (pt) => !pt.associatedMaterialTypes?.some((m) => m.id !== null)
      );
      if (invalidRows.length > 0) {
        setErrorMessage(
          `Associated Material Types cannot be empty. Please add at least one material type for: ${invalidRows.map((pt) => pt.name).join(", ")}.`
        );
        return;
      }

      setIsSaving(true); // Start loading

      // Prepare the payload
      const payload = {
        ecosystemId: addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
        sponsorId:
          addSponsorList?.data?.organizationId || rowData?.organizationId,
        productTypeList: isAnyProductTypeSelected.map(
          ({ id, name, selected, associatedMaterialTypes }) => ({
            productTypeID: id,
            productTypeName: name,
            activated: selected,
            markForDelete: false,
            associatedMaterialTypesList:
              associatedMaterialTypes?.map((material) => ({
                materialTypeName: material?.name,
                materialTypeID: material?.id,
                productDomEqualsMaterialDom: material?.productDomEqualsMaterialDom ?? false,
              })) || [],
          })
        ),
      };

      // Call the API
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateProductTypes`;
      const response = await axios.post(url, payload);

      // Handle API response
      if (response.data?.status === true || response.data?.status === "true") {
        await fetchProductTypes(); // Refresh the product types list
        setErrorMessage(""); // Clear any previous error messages
        props.handleNext(); // Proceed to the next tab
      } else {
        console.error("Failed to update Product Types.");
        setErrorMessage("Failed to update Product Types. Please try again.");
      }
    } catch (error) {
      console.error("Error updating Product Types:", error);
      setErrorMessage(
        "An error occurred while updating Product Types. Please try again."
      );
    } finally {
      setIsSaving(false); // Stop loading
    }
  };

  const deleteProductType = async (productType) => {
      try {
      if (productType.isNew) {
        // If the product type is new and not yet saved, remove it from the state
        setProductTypes((prevProductTypes) =>
          prevProductTypes.filter((item) => item.id !== productType.id)
        );
      } else {
        // If the product type is already saved, send a delete request to the API
        const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateProductTypes`;
        const payload = {
          ecosystemId:
            addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
          sponsorId:
            addSponsorList?.data?.organizationId || rowData?.organizationId,
          productTypeList: [
            {
              productTypeID: productType.id, // Use the Product Type ID
              productTypeName: productType.name, // Product Type name
              activated: productType.selected, // Activation status
              markForDelete: true, // Mark the Product Type for deletion
              associatedMaterialTypesList:
                productType?.associatedMaterialTypes?.map((product) => ({
                  materialTypeName: product?.name, // Product type name
                  materialTypeID: product?.id, // Product type ID
                  productDomEqualsMaterialDom: product?.productDomEqualsMaterialDom ?? false,
                })),
            },
          ],
        };
        const response = await axios.post(url, payload);

        // Refresh the product types list after deletion
        if (
          response.data?.status === true ||
          response.data?.status === "true"
        ) {
          await fetchProductTypes(); // Refresh the product types list
          props.setProductType((prev) => !prev);
        } else {
          console.error("Failed to delete Product Type.");
        }
      }
    } catch (error) {
      console.error("Error deleting Product Type:", error);
    }
  };

  const handleToggle = (index) => {
    const updated = [...productTypes]; // Create a shallow copy of the `productTypes` array
    updated[index].selected = !updated[index].selected; // Toggle the `selected` property of the product type at the given index
    updated[index].isUpdated = true;
    setProductTypes(updated); // Update the state with the modified array
    setIsUpdated(true); // Optional: Track changes if needed
  };

  const handleNameChange = (index, value) => {
    const updated = [...productTypes];
    updated[index].name = value;
    setProductTypes(updated);
    if (rowErrors[index]?.name) {
      setRowErrors((prev) => ({ ...prev, [index]: { ...prev[index], name: "" } }));
    }
  };

  const handleDelete = (index) => {
    const updated = productTypes.filter((_, i) => i !== index);
    setProductTypes(updated);
  };

  const handleAddProductType = () => {
    fetchProductOptions();
    setProductTypes([
      ...productTypes,
      {
        name: "",
        selected: false,
        isNew: true,
        // Start with one empty editable material row so selects appear immediately
        products: [{ id: null, name: "", productDomEqualsMaterialDom: false, isEditing: true }],
      },
    ]);
  };
  const handleCancel = (index) => {
    setProductTypes((prev) => prev.filter((_, i) => i !== index));
    setRowErrors((prev) => {
      const next = { ...prev };
      delete next[index];
      return next;
    });
  };

  // BCM-322: Add a new material type sub-row — flagged isEditing so controls stay active
  const handleAddMaterialType = (productTypeIndex) => {
    setProductTypes((prev) =>
      prev.map((row, i) => {
        if (i !== productTypeIndex) return row;
        const key = row.isNew ? "products" : "associatedMaterialTypes";
        const currentList = row[key] || [];
        return {
          ...row,
          [key]: [
            ...currentList,
            { id: null, name: "", productDomEqualsMaterialDom: false, isEditing: true },
          ],
          isUpdated: true,
        };
      })
    );
    setIsUpdated(true);
  };

  // BCM-322: Handler to remove a material type sub-row from a product type
  const handleRemoveMaterialType = (productTypeIndex, materialIndex) => {
    setProductTypes((prev) =>
      prev.map((row, i) => {
        if (i !== productTypeIndex) return row;
        const key = row.isNew ? "products" : "associatedMaterialTypes";
        const currentList = row[key] || [];
        return {
          ...row,
          [key]: currentList.filter((_, j) => j !== materialIndex),
          isUpdated: true,
        };
      })
    );
    setIsUpdated(true);
  };

  // BCM-322: Change the DoM flag — preserves isEditing so DoM remains editable
  const handleDomFlagChange = (productTypeIndex, materialIndex, value) => {
    setProductTypes((prev) =>
      prev.map((row, i) => {
        if (i !== productTypeIndex) return row;
        const key = row.isNew ? "products" : "associatedMaterialTypes";
        const currentList = row[key] || [];
        let newList;
        if (currentList.length === 0 && materialIndex === 0) {
          // Virtual empty row — auto-create entry in state
          newList = [{ id: null, name: "", productDomEqualsMaterialDom: value, isEditing: true }];
        } else {
          newList = currentList.map((mat, j) =>
            j === materialIndex ? { ...mat, productDomEqualsMaterialDom: value } : mat
          );
        }
        return { ...row, [key]: newList, isUpdated: true };
      })
    );
    setIsUpdated(true);
  };

  // BCM-322: Select a material type — preserves isEditing so DoM stays editable after selection
  const handleMaterialTypeSelect = (productTypeIndex, materialIndex, selectedOption) => {
    setProductTypes((prev) =>
      prev.map((row, i) => {
        if (i !== productTypeIndex) return row;
        const key = row.isNew ? "products" : "associatedMaterialTypes";
        const currentList = row[key] || [];
        let newList;
        if (currentList.length === 0 && materialIndex === 0) {
          // Virtual empty row — auto-create entry in state
          newList = [{
            id: selectedOption.id,
            name: selectedOption.name,
            productDomEqualsMaterialDom: false,
            isEditing: true,
          }];
        } else {
          newList = currentList.map((mat, j) =>
            j === materialIndex
              ? { ...mat, id: selectedOption.id, name: selectedOption.name }
              // isEditing is spread-preserved → DoM dropdown stays active
              : mat
          );
        }
        return { ...row, [key]: newList, isUpdated: true };
      })
    );
    setIsUpdated(true);
    if (rowErrors[productTypeIndex]?.materials) {
      setRowErrors((prev) => ({
        ...prev,
        [productTypeIndex]: { ...prev[productTypeIndex], materials: "" },
      }));
    }
  };

  return (
    <div className={classes.container}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Selection</TableCell>
            <TableCell className={classes.headerCell}>Product Type</TableCell>
            <TableCell className={classes.headerCell}>
              Product Type ID
            </TableCell>
            <TableCell className={classes.headerCell}>
              Associated Material Types
            </TableCell>
            <TableCell className={classes.headerCell}>
              Product DoM = Material DoM
            </TableCell>
            <TableCell className={classes.headerCell}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={6}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100px",
                  }}
                >
                  <CircularProgress />
                </div>
              </TableCell>
            </TableRow>
          ) : error ? (
            <TableRow>
              <TableCell colSpan={6}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60px",
                    backgroundColor: "#ffecec",
                    color: "#b00020",
                    border: "1px solid #ff9999",
                  }}
                >
                  <Typography>{error}</Typography>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            productTypes.map(
              (
                item,
                index // Debugging
              ) => (
                <TableRow key={item.id}>
                  <TableCell className={classes.bodyCell}>
                    <Switch
                      checked={item.selected}
                      onChange={() => handleToggle(index)}
                      classes={{ switchBase: classes.switchBase }}
                    />
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {item.isNew ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <TextField
                            placeholder="Type Text Here"
                            value={item.name}
                            onChange={(e) =>
                              handleNameChange(index, e.target.value)
                            }
                            onBlur={(e) => {
                              const trimmed = e.target.value.trim();
                              if (trimmed !== e.target.value) {
                                handleNameChange(index, trimmed);
                              }
                            }}
                            className={classes.textField}
                            variant="outlined"
                            error={!!rowErrors[index]?.name}
                            inputProps={{
                              onBeforeInput: (e) => {
                                const allowedChars = /^[a-zA-Z0-9\s()/\-\.]+$/;
                                if (!allowedChars.test(e.data)) {
                                  e.preventDefault();
                                }
                              },
                            }}
                          />
                          {rowErrors[index]?.name && (
                            <Typography style={{ color: "red", fontSize: 11, marginTop: 2 }}>
                              {rowErrors[index].name}
                            </Typography>
                          )}
                        </div>
                      </div>
                    ) : (
                      item.name
                    )}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>{item.id}</TableCell>
                  {/* BCM-322: Associated Material Types column - sub-row pattern */}
                  <TableCell className={classes.bodyCell} style={{ verticalAlign: "top" }}>
                    {(() => {
                      const isDefault = item.type?.toLowerCase() === "default";
                      const materials = item.isNew
                        ? (item.products || [])
                        : (item.associatedMaterialTypes || []);
                      // When materials list is empty, show a virtual empty row so selects appear immediately
                      const emptyEditableMaterial = { id: null, name: "", productDomEqualsMaterialDom: false, isEditing: true };
                      const effectiveMaterials =
                        materials.length === 0 && !isDefault
                          ? [emptyEditableMaterial]
                          : materials;
                      return (
                        <div>
                          {effectiveMaterials.map((material, matIdx) => {
                            const isLastMaterial = matIdx === effectiveMaterials.length - 1;
                            return (
                              <div
                                key={matIdx}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom: 4,
                                  minHeight: 36,
                                }}
                              >
                                {/* isEditing → dropdown; otherwise → plain text */}
                                {material.isEditing ? (
                                  <Select
                                    displayEmpty
                                    value={material.id || ""}
                                    onChange={(e) => {
                                      const selected = productOptions.find(
                                        (opt) => opt.id === e.target.value
                                      );
                                      if (selected) {
                                        handleMaterialTypeSelect(index, matIdx, selected);
                                      }
                                    }}
                                    onOpen={fetchProductOptions}
                                    renderValue={(val) =>
                                      val
                                        ? productOptions.find((opt) => opt.id === val)?.name || "Select"
                                        : "Select from dropdown"
                                    }
                                    style={{ width: 180 }}
                                    size="small"
                                    variant="outlined"
                                  >
                                    {productOptions
                                      .filter(
                                        (opt) =>
                                          !effectiveMaterials.some(
                                            (m, mi) => mi !== matIdx && m.id === opt.id
                                          )
                                      )
                                      .map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                          {option.name}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                ) : (
                                  <Typography style={{ minWidth: 150 }}>
                                    {material.name}
                                  </Typography>
                                )}

                                {/* ⊕ Add button — inline on the last material row */}
                                {!isDefault && isLastMaterial && (
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      fetchProductOptions();
                                      handleAddMaterialType(index);
                                    }}
                                    title="Add material type"
                                    style={{ marginLeft: 2 }}
                                  >
                                    <AddCircleOutlineIcon fontSize="small" style={{ color: "#007bff" }} />
                                  </IconButton>
                                )}

                                {/* Delete — only for isEditing rows that exist in real state */}
                                {!isDefault && material.isEditing && materials.length > 0 && (
                                  <IconButton
                                    size="small"
                                    onClick={() => handleRemoveMaterialType(index, matIdx)}
                                    style={{ marginLeft: 2 }}
                                  >
                                    <DeleteIcon fontSize="small" className={classes.deleteIcon} />
                                  </IconButton>
                                )}
                              </div>
                            );
                          })}
                          {item.isNew && rowErrors[index]?.materials && (
                            <Typography style={{ color: "red", fontSize: 11, marginTop: 2 }}>
                              {rowErrors[index].materials}
                            </Typography>
                          )}
                        </div>
                      );
                    })()}
                  </TableCell>
                  {/* BCM-322: Product DoM = Material DoM column - sub-row pattern */}
                  <TableCell className={classes.bodyCell} style={{ verticalAlign: "top" }}>
                    {(() => {
                      const isDefault = item.type?.toLowerCase() === "default";
                      const materials = item.isNew
                        ? (item.products || [])
                        : (item.associatedMaterialTypes || []);
                      const emptyEditableMaterial = { id: null, name: "", productDomEqualsMaterialDom: false, isEditing: true };
                      const effectiveMaterials =
                        materials.length === 0 && !isDefault
                          ? [emptyEditableMaterial]
                          : materials;
                      return (
                        <div>
                          {effectiveMaterials.map((material, matIdx) => (
                            <div
                              key={matIdx}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 4,
                                minHeight: 36,
                              }}
                            >
                              {/* isEditing → editable Select; otherwise → plain text */}
                              {material.isEditing ? (
                                <Select
                                  value={material.productDomEqualsMaterialDom ? "Yes" : "No"}
                                  onChange={(e) =>
                                    handleDomFlagChange(index, matIdx, e.target.value === "Yes")
                                  }
                                  style={{ width: 100 }}
                                  size="small"
                                  variant="outlined"
                                >
                                  <MenuItem value="Yes">Yes</MenuItem>
                                  <MenuItem value="No">No</MenuItem>
                                </Select>
                              ) : (
                                <Typography style={{ minWidth: 40 }}>
                                  {material.productDomEqualsMaterialDom ? "Yes" : "No"}
                                </Typography>
                              )}
                            </div>
                          ))}
                        </div>
                      );
                    })()}
                  </TableCell>
                  {/* Action column */}
                  <TableCell className={classes.bodyCell} style={{ verticalAlign: "top" }}>
                    {item.isNew ? (
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <IconButton
                          onClick={() => handleCancel(index)}
                          className={classes.iconBtn}
                        >
                          <CancelIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => handleSaveNewProductType(index)}
                          className={classes.iconBtn}
                          disabled={
                            !productTypes[index].name?.trim() ||
                            productTypes.some(
                              (f, i) =>
                                i !== index &&
                                f.name?.trim().toLowerCase() ===
                                  productTypes[index].name?.trim().toLowerCase()
                            ) ||
                            !(
                              productTypes[index].products?.length &&
                              productTypes[index].products.every((p) => p.id !== null)
                            ) ||
                            savingStates[index]
                          }
                        >
                          <SaveIcon fontSize="small" />
                        </IconButton>
                      </div>
                    ) : (
                      (item.type === "New") && (
                        <IconButton
                          aria-label="delete"
                          onClick={() => deleteProductType(item)}
                        >
                          <DeleteIcon className={classes.deleteIcon} />
                        </IconButton>
                      )
                    )}
                  </TableCell>
                </TableRow>
              )
            )
          )}
        </TableBody>
      </Table>
      {errorMessage && (
        <div style={{ color: "red" }} className="error-message">
          {errorMessage}
        </div>
      )}

      <Button
        variant="outlined"
        onClick={handleAddProductType}
        className={classes.addButton}
      >
        <span className={classes.addIconCircle}>+</span>
        Add New Product Type
      </Button>

      <div className={classes.footer}>
        <Grid
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          <ChevronLeftIcon />
          Back
        </Grid>
        <Grid
          className={classes.saveButton}
          onClick={() => {
            if (isUpdated) {
              handleNextClick(); // Call API and move to the next tab if updates are made
            } else {
              props.handleNext(); // Directly move to the next tab if no updates are made
            }
          }}
          style={{ 
            opacity: isSaving ? 0.7 : 1, 
            pointerEvents: isSaving ? 'none' : 'auto' 
          }}
        >
          {isSaving ? (
            <>
              <CircularProgress size={16} color="inherit" style={{ marginRight: '8px' }} />
              Saving...
            </>
          ) : (
            <>
              Save & Next
              <ChevronRightIcon />
            </>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default ProductTypeTab;
